/**
 * 推广返利管理 - 提现 API
 *
 * 对应后端: /admin/referral/withdrawals
 */

import httpRequest from '@/utils/api'
import type { AdminWithdrawalListData, WithdrawalRecord, WithdrawalRejectRequest } from '@/types/referral/withdrawal'

enum API {
  withdrawals = '/admin/referral/withdrawals',
}

/** 获取提现记录列表（分页，可按状态筛选） */
export const getWithdrawalsAPI = (
  page: number = 1,
  pageSize: number = 20,
  statusFilter?: string,
) => {
  return httpRequest.get<AdminWithdrawalListData>({
    url: API.withdrawals,
    params: { page, page_size: pageSize, status_filter: statusFilter },
  })
}

/** 审核通过 */
export const approveWithdrawalAPI = (withdrawalId: number) => {
  return httpRequest.post<WithdrawalRecord>({
    url: `${API.withdrawals}/${withdrawalId}/approve`,
  })
}

/** 审核拒绝 */
export const rejectWithdrawalAPI = (withdrawalId: number, data: WithdrawalRejectRequest) => {
  return httpRequest.post<WithdrawalRecord>({
    url: `${API.withdrawals}/${withdrawalId}/reject`,
    data,
  })
}
